import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { DragulaModule } from 'ng2-dragula';

import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { CookieModule } from 'ngx-cookie';
import { NgxPendoModule } from 'ngx-pendo';
import { QuillModule } from 'ngx-quill';

import { effects, getInitialState, reducers } from '®app/ngrx';

import { environment } from '®environments/environment';

import { AuthModule } from '®shared/auth';
import { configureApp, AppConfig } from '®shared/config';
import { CurrentUserModule } from '®shared/current-user';
import { EventsModule } from '®shared/events';
import { LoaderModule } from '®shared/loader';
import { LtiRelinkModule } from '®shared/lti-relink';
import { NavbarModule } from '®shared/navbar';
import { PendoModule } from '®shared/pendo';
import { TenantModule } from '®shared/tenant';

import { AppErrorHandler } from './app-error-handler.service';
import { AppComponent } from './app.component';
import { routing } from './app.routing';
import { ErrorPageModule } from './error-page';
import { PageNotFoundModule } from './page-not-found';
import { ItemModeResolverModule } from './reading-lists/item-view/mode-resolver';
import { ListModeResolverModule } from './reading-lists/list/mode-resolver';
import { SectionModeResolverModule } from './reading-lists/section-view/mode-resolver';

// configure main module
@NgModule({
  declarations: [AppComponent],
  imports: [
    AuthModule.forRoot(),
    BrowserModule,
    BrowserAnimationsModule,
    CollapseModule.forRoot(),
    CookieModule.forRoot(),
    CurrentUserModule.forRoot(),
    BsDropdownModule.forRoot(),
    DragulaModule.forRoot(),
    EffectsModule.forRoot(effects),
    ErrorPageModule,
    EventsModule.forRoot(),
    ListModeResolverModule,
    LoaderModule,
    LtiRelinkModule,
    ItemModeResolverModule,
    ModalModule.forRoot(),
    NavbarModule,
    PageNotFoundModule,
    PendoModule,
    QuillModule.forRoot(),
    SectionModeResolverModule,
    StoreModule.forRoot(reducers, { initialState: getInitialState }),
    environment.production ? [] : StoreDevtoolsModule.instrument(),
    TenantModule,
    TooltipModule.forRoot(),
    routing,
    NgxPendoModule.forRoot({
      pendoApiKey: '92857921-200c-48c4-761b-2b7f827ffd3a',
    }),
  ],
  providers: [
    { provide: AppConfig, useFactory: configureApp },
    { provide: ErrorHandler, useClass: AppErrorHandler },
    Title,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
